import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const YandexTrialsBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
  column-gap: 16px;
  width: 100%;
  margin: 24px 0;

  @media (max-width: 1023px) {
    flex-direction: column;
    row-gap: 18px;
  }
`;

export const YandexPrice = styled.div`
  ${FONTS.M};
  font-size: 18px;
  line-height: 1.333;
  margin: 24px 0;

  @media(max-width: 767px) {
    font-size: 14px;
  }
`;
